import React from 'react'
import tw from 'tailwind-styled-components'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {cn} from '@containers/html-utils'

const TwContainer = tw.div`
  flex
  flex-col

  bg-grey-l100

  border-1
  border-solid
  border-grey-l60
  rounded-8

  perfect-scrollbar-with-custom-scroll
`

export const TwCaption = tw.div`
  font-semibold
  text-14
  leading-4
  text-primary
  cursor-default
  whitespace-nowrap

  h-32
  box-border
  px-12
  py-8

  border-0
  border-b-1
  border-solid
  border-grey-l60
`

export const TwContent = tw.div`
  flex
  flex-col
  py-8
  cursor-pointer
`

interface Props {
  children?: React.ReactNode | string
  className?: string
  classNameContent?: string
  caption?: string
  onClick?: () => void
  maxWidth?: string
}

export const DropdownMenuContainer = (props: Props) => {
  const {children, className, caption, onClick} = props
  const {classNameContent} = props

  return (
    <TwContainer className={cn(className, 'shadow-tooltip')} onClick={onClick}>
      {caption && <TwCaption>{caption}</TwCaption>}
      <WithPerfectScrollbar className="max-h-400">
        <TwContent className={classNameContent}>{children}</TwContent>
      </WithPerfectScrollbar>
    </TwContainer>
  )
}
